import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { UserSessionService } from './user-session.service';
import { API_BASE_URL } from './api-base';

interface LogPayload {
  user_id: number | null;
  tenant_id?: number | null;
  event_type: string;
  event_description: string;
  ip_address: string;
  user_agent: string;
}

@Injectable({
  providedIn: 'root'
})
export class LogService {

  private apiUrl = `${API_BASE_URL}/logs/register`;

  constructor(private http: HttpClient, private userSession: UserSessionService) {}

  register(eventType: string, description: string, overrides?: Partial<LogPayload>): Observable<unknown> {
    const user = this.userSession.getUser();

    if (!user?.id && !overrides?.user_id) {
      return of(null);
    }

    const payload: LogPayload = {
      user_id: overrides?.user_id ?? user?.id ?? null,
      tenant_id: overrides?.tenant_id ?? user?.tenant_id ?? null,
      event_type: eventType,
      event_description: description,
      ip_address: overrides?.ip_address ?? window.location.hostname,
      user_agent: overrides?.user_agent ?? navigator.userAgent
    };

    if (navigator.sendBeacon) {
      try {
        const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
        navigator.sendBeacon(this.apiUrl, blob);
        return of(null);
      } catch (_) {}
    }

    return this.http.post(this.apiUrl, payload).pipe(
      take(1),
      catchError(() => of(null))
    );
  }
}
